import React from "react";
import { DateTimePicker } from "@mui/x-date-pickers";
import { Typography } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

const DateSelector = ({
  name,
  value,
  error,
  onPick,
  views,
  disabled = false,
  format = "dd/MM/yyyy",
}) => {
  const normalizeFormat = (fmt) =>
    fmt
      .replace(/YYYY/g, "yyyy")
      .replace(/YY/g, "yy")
      .replace(/DD/g, "dd")
      .replace(/d{1}(?!d)/g, "d")
      .replace(/MM/g, "MM")
      .replace(/HH/g, "HH")
      .replace(/hh/g, "hh")
      .replace(/mm/g, "mm")
      .replace(/ss/g, "ss");

  const normalizedFormat = normalizeFormat(format);

  const valueDate = (() => {
    if (!value) return null;
    const date = value instanceof Date ? value : new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
  })();

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Typography variant="body1" sx={{mb: 1}}>
        {name}
      </Typography>
      <DateTimePicker
        views={views || ["year", "month", "day"]}
        value={valueDate}
        onChange={(newValue) => {
          if (!newValue) {
            onPick(null);
            return;
          }
          const localDate = new Date(newValue);
          onPick(localDate.toLocaleString()); // or localDate.getTime() if you want timestamp
        }}
        format={normalizedFormat}
        disabled={disabled}
        slotProps={{
          textField: {
            fullWidth: true,
            error: !!error,
            helperText: error ? (
              <Typography variant="body2" marginTop={1} color="error">
                {error}
              </Typography>
            ) : null,
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default DateSelector;
